import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  readonly isLoading = signal(false);
  startLoading() {
    this.isLoading.set(true);
  }
  stopLoading() {
    this.isLoading.set(false);
  }
}
